import {
  CandidateBuilder,
  GetShareCandidatesInput,
  GetShareCandidatesOutput,
} from '../candidates.types';

export const getShareCandidate = (builder: CandidateBuilder) =>
  builder.query<GetShareCandidatesOutput, GetShareCandidatesInput>({
    query: (query) => {
      const params = new URLSearchParams();
      params.append('name', query.name);
      query.ids.forEach((singleCandidateId) => {
        params.append('ids', `${singleCandidateId}`);
      });
      return {
        url: `/candidates/share?${params.toString()}`,
        method: 'GET',
      };
    },
  });
